<div class="background" [ngStyle]="{
              'background-image': cmsService.getCmsContent()()?.landingpage_image ?
              'url('+(cmsService.getCmsContent()().landingpage_image | transformCmsUrl)+')':
              'url( ../../assets/bg/img.png)'
            }">
  @if (statusMeldung?.acf?.landingpage) {
    <app-important-message></app-important-message>
  }
  <div class="background">


    <div class="header">
      <div class="nav-logo">
        <img alt="nv-logo" src="./assets/nv_logo.png"/>
        <h3 class="desktop">
          <span class="bold">Meine NV</span>
          <span class="light no-displ-under-600px"> - Das smarte Kundenportal</span>
        </h3>
        <div (click)="menu.openMenu()" class="info-menu row shift-to-right" #toggle>
          <i class="material-icons flip-icon">clear_all</i>
          <p>Informationen</p>
        </div>
      </div>
    </div>
    <app-burger-menu #menu [toggleElementRef]="toggleRef"></app-burger-menu>
    <div class="card-container">
      <div class="nav-bar-container">
        @if (currentBackURL()) {
          <app-navbar [backURL]="currentBackURL()" [skipMobileView]="true"></app-navbar>
        }
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
